import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ngp_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const LOGO = "https://customer-assets.emergentagent.com/job_11bcae0a-07d0-416f-955e-9ac51f5fec6d/artifacts/u3ktrg9k_Next%20Gen%20Praise%20Logo2.jpeg";
export const LOGO_DARK = "https://customer-assets.emergentagent.com/job_11bcae0a-07d0-416f-955e-9ac51f5fec6d/artifacts/ombnlg2l_Next%20Gen%20Praise%20Logo.jpeg";

export const WHATSAPP_NUMBER = "27735465752";

export const formatZAR = (v) => new Intl.NumberFormat("en-ZA", { style: "currency", currency: "ZAR", maximumFractionDigits: 0 }).format(v || 0);

// Resolve any image/file URL — prefix backend host if it's a relative /api/files/... path
export const resolveUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};
